import { render, staticRenderFns } from "./color_palette_demo.vue?vue&type=template&id=79a5b9e1&scoped=true&"
import script from "./color_palette_demo.vue?vue&type=script&lang=ts&"
export * from "./color_palette_demo.vue?vue&type=script&lang=ts&"
import style0 from "./color_palette_demo.vue?vue&type=style&index=0&id=79a5b9e1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a5b9e1",
  null
  
)

export default component.exports